import React, { Component } from 'react'

export default class WalletFailed extends Component {
    render() {
        return (
            <div className="card checkout-step-one">

                <section className="breadcrumb-bg mt-5">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-sm-12 text-center">
                                <div className="page-title order-done ">

                                    <i className="mdi mdi-close-circle-outline text-secondary" style={{ fontSize: '14rem' }}/>

                                   <h1>Transaction Failed</h1>
                                    <p className="col-sm-6 mx-auto mt-3 mb-5">Oops! Your payment has been declined. Please try again later</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
               
            </div>
        )
    }
}
